import React, { useEffect, useState } from 'react';
import { CFormFeedback, CMultiSelect, CFormLabel } from '@coreui/react-pro';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { generateId, jsonAndCompare } from '../../../utils';
import usePrevious from '../../../helpers/hooks/usePrevious';

const SimpleMultiSelectGroup = ({
     id,
     label,
     name,
     className,
     error,
     options,
     isRequired,
     setFieldValue,
     onChangeCustom,
     hasDisable,
     selectionType,
     multiple,
     reloadSelect,
}) => {
     const [key, setKey] = useState(generateId());
     const prevOptions = usePrevious(options);

     const handleChangeSelect = (selected) => {
          const btnSelectCloses = document.getElementsByClassName('form-multi-select-tag-delete');

          for (let i = 0; i < btnSelectCloses.length; i++) {
               const btnSelectClose = btnSelectCloses[i];
               btnSelectClose.setAttribute('type', 'button');
          }

          if (onChangeCustom) {
               onChangeCustom(selected);
          } else {
               setFieldValue(id, selected);
          }
     };

     useEffect(() => {
          if (reloadSelect && !jsonAndCompare(options, prevOptions)) {
               setKey(generateId());
          }
     }, [options, prevOptions, reloadSelect]);

     // Handle click icon dropdown with select
     useEffect(() => {
          if (selectionType === 'tags') {
               return;
          }

          const formMultiSelect = document.querySelector('.form-multi-select');
          const formMultiSelectSearch = document.querySelector('.form-multi-select-search');

          const handleClickSelect = () => {
               formMultiSelectSearch.click();
          };

          formMultiSelect.addEventListener('click', handleClickSelect);

          return () => {
               formMultiSelect.removeEventListener('click', handleClickSelect);
          };
     }, []); // eslint-disable-line react-hooks/exhaustive-deps

     return (
          <div key={key} className={classNames('form-group', { [className]: className })}>
               {label && (
                    <CFormLabel htmlFor={name}>
                         {<span className="me-1">{label}</span>}
                         {isRequired && <span className="text-danger">*</span>}
                    </CFormLabel>
               )}
               <CMultiSelect
                    id={id}
                    className={`form-select ${isRequired && !!error ? 'is-invalid' : ''}`}
                    disabled={hasDisable}
                    options={options}
                    invalid={isRequired && !!error}
                    selectionType={selectionType}
                    multiple={multiple}
                    optionsStyle={multiple ? 'checkbox' : 'text'}
                    virtualScroller
                    onChange={handleChangeSelect}
               />

               {isRequired && <CFormFeedback invalid>{error}</CFormFeedback>}
          </div>
     );
};

SimpleMultiSelectGroup.propTypes = {
     id: PropTypes.string,
     label: PropTypes.string,
     name: PropTypes.string,
     className: PropTypes.string,
     isRequired: PropTypes.bool,
     error: PropTypes.string,
     handleChange: PropTypes.func,
     options: PropTypes.any,
     selectionType: PropTypes.string,
     multiple: PropTypes.bool,
     hasDisable: PropTypes.bool,
};

SimpleMultiSelectGroup.defaultProps = {
     options: [],
     selectionType: 'tags',
     multiple: true,
};

export default SimpleMultiSelectGroup;
